import React, { FunctionComponent } from 'react';
import classNames from 'classnames';

import styles from './Layout.module.scss';
import { BRAND } from '../../constants/brand';

interface LayoutProps {
  className?: string;
}

const Layout: FunctionComponent<LayoutProps> = ({ children, className }) => {
  const layoutClass = classNames(
    `${BRAND.SUPER_SHORT_NAME}-layout`,
    className,
    {
      [styles.layout]: true,
    },
  );

  return <div className={layoutClass}>{children}</div>;
};

export default Layout;
